<template>
  <b-card no-body>
    <div style="display:block" id="listaRequests">
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <!-- filter -->
          <b-form-group label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-card-body>
      <b-table responsive class="position-relative" :busy="isLoading" :per-page="perPage" :current-page="currentPage" :items="items"
        :small="true" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        :filter="filter" :filter-included-fields="filterOn" @filtered="cPaginacion">
        <template #cell(actions)="data">
          <div v-if="!isPresented">
            <div class="text-nowrap">
              <feather-icon :id="`${data.item.id}-edit-icon`" icon="EditIcon" class="cursor-pointer" size="16"
                @click="$router.push({ name: 'edit', params: { id: data.item.id } })" />
              <b-tooltip title="Editar puesto" class="cursor-pointer" :target="`${data.item.id}-edit-icon`" />
            </div>
          </div>
          <div v-else>
            <div class="text-nowrap">
              <feather-icon :id="`${data.item.id}-view-icon`" icon="EyeIcon" class="cursor-pointer" size="16"
                @click="$router.push({ name: 'presented', params: { id: data.item.id } })" />
              <b-tooltip title="Ver puesto" class="cursor-pointer" :target="`${data.item.id}-view-icon`" />
            </div>
          </div>
        </template>
        <template #cell(joining_type)="data">
          <div v-if="data.item.joining_type == 'Reducción de posición'">
            <del>{{ data.item.joining_type }}</del>
          </div>
          <div v-else>
            {{ data.item.joining_type }}
          </div>
        </template>
        <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm" label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1">
          <b-form-select id="perPageSelect2" v-model="perPage" size="sm" inline :options="pageOptions" />
        </b-form-group>
        <!-- pagination -->
        <div>
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
            prev-class="prev-item" next-class="next-item" class="mb-0">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </div>
  </b-card>
</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import {
  BCard,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BModal,
  VBModal,
  BRow,
  BCol,
  BProgress,
  BTooltip,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BModal,
    BRow,
    BCol,
    BProgress,
    BTooltip,
    BSpinner,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      items : [],
      isLoading: true,
      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'table',
          label: 'Tabla',
          sortable: true,
        },
        {
          key: 'function_executed',
          label: 'Funcion Ejecutada',
          sortable: true,
        },
        {
          key: 'user_id',
          label: 'User ID',
          sortable: true,
        },
        {
          key: 'execution_date',
          label: 'Fecha',
          sortable: true,
        },

        {
          key: 'execution_time',
          label: 'Hora',
          sortable: true,
        },
        {
          key: 'event_type',
          label: 'Tipo de Evento',
          sortable: true,
        },
        {
          key: 'execution_result',
          label: 'Resultado',
          sortable: true,
        },
        {
          key: 'records_affected',
          label: 'Filas afectadas',
          sortable: true,
        },
        {
          key: 'execution_detail',
          label: 'Detalles',
          sortable: true,
        },
      ],
      items: [],
    }
  },
  mounted() {
  },
  created() {
    this.getLogs()
  },
  methods: {
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getLogs() {
      const URL = '/nomina/admin/get_logs'
      const config = {
        method: 'get', url: URL, params: {
          user_id: this.getUserID(),
          app_user_id: this.getUserID(),
        }
      }
      this.isLoading = true
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.isLoading = false
            this.items = response.data.response.data
            this.totalRows = this.items.length
          }
        })
        .catch(error => {
          this.isLoading = false
          this.printErrorModal(error)
        });
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
